module.exports = __webpack_public_path__ + "img/smashbros.8fbf24d1.png";